// web/src/lib/email-template-assets.ts
//
// Task B4 — API client for the email-templates inline-image library
// (`/api/email-templates/inline-images`). Assets are uploaded once and
// referenced by CID from one or more template bodies.
import { apiFetch } from "./api";

export interface EmailTemplateAsset {
  id: number;
  fileName: string;
  contentType: string;
  width: number | null;
  height: number | null;
  sizeBytes: number;
  usedByTemplateIds: number[];
}

export const emailTemplateAssetsApi = {
  list: () => apiFetch<EmailTemplateAsset[]>("/api/email-templates/inline-images"),
  upload: (file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return apiFetch<EmailTemplateAsset>("/api/email-templates/inline-images", {
      method: "POST",
      body: fd,
    });
  },
  remove: (id: number) =>
    apiFetch<void>(`/api/email-templates/inline-images/${id}`, { method: "DELETE" }),
};
